// extracted by mini-css-extract-plugin
module.exports = {"container":"simple-module--container--kDWP-","item":"simple-module--item--1EoHR"};